/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Footer_ResourcesInputs */

const en_marketing_footer_resources = /** @type {(inputs: Marketing_Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const es_marketing_footer_resources = /** @type {(inputs: Marketing_Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const fr_marketing_footer_resources = /** @type {(inputs: Marketing_Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Marketing_Footer_ResourcesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_footer_resources = /** @type {((inputs?: Marketing_Footer_ResourcesInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Footer_ResourcesInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_footer_resources(inputs)
	if (locale === "es") return es_marketing_footer_resources(inputs)
	return fr_marketing_footer_resources(inputs)
});